<template>
    <div>
        <transition-group name="list" tag="div">
            <div v-for="(result, index) in results" :key="result.id + '-' + index">
                <slot name="list" :index="index" :result="result" :search-city="searchCity"
                      :go-to-link="goToLink"></slot>
            </div>
        </transition-group>
        <div v-if="fetchAllowed()" class="text-center mb-5">
            <button @click="loadMore"
                    :disabled="loading"
                    type="button"
                    class="btn btn-primary load-more">
                <div v-if="loading" class="spinner"></div>
                <div :style="{visibility: loading ? 'hidden' : 'visible'}">{{ transLoadMore }}</div>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'lazy-load',
    props: {
        initialEndpoint: {
            type: String,
            required: true
        },
        pageName: {
            type: String,
            default: 'page'
        },
        params: {
            type: Object,
            default: () => ({})
        },
        pageLimit: {
            type: Number,
            default: 10
        },
        transLoadMore: {
            type: String,
            default: 'Load more'
        },
        searchCity: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            endpoint: this.updateEndpoint(this.initialEndpoint),
            results: [],
            currentPage: 1,
            loading: false,
            emptyResults: false
        }
    },
    methods: {
        fetch() {
            if (!this.fetchAllowed()) {
                    return new Promise((resolve, reject) => {
                });
            }

            this.loading = true;

            return new Promise((resolve, reject) => {
                window.axios(this.endpoint)
                    .then(response => {
                        const meta = response.data.meta;
                        const results = response.data.data;

                        this.currentPage = meta.current_page;

                        this.endpoint = this.updateEndpoint(response.data.links.next);

                        if (results.length) {
                            this.results.push(...results);
                        }

                        if (!results.length || results.length < meta.per_page) {
                            this.emptyResults = true;
                        }

                        this.loading = false;

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        this.loading = false;

                        reject(error);
                    });
            });
        },
        loadMore() {
            this.fetch();
        },
        fetchAllowed() {
            return this.endpoint && !this.emptyResults && this.currentPage < this.pageLimit;
        },
        goToLink(link) {
            window.location.href = link;
        },
        updateBrowserCurrentUrl(meta) {
            let url = new URL(window.location.href);
            let searchParams = url.searchParams;
            searchParams.set(this.pageName, meta.current_page);

            url.search = searchParams.toString();

            history.replaceState(null, null, url.toString());
        },
        updateEndpoint(nextLink) {
            if (!nextLink) {
                return null;
            }

            const self = this;

            let url = new URL(nextLink);
            let searchParams = url.searchParams;

            Object.keys(self.params).forEach((key) => {
                searchParams.set(key, self.params[key]);
            });

            searchParams.set('t', (new Date().getTime()).toString());

            url.search = searchParams.toString();

            return url.toString();
        }
    },
    mounted() {
        let url = new URL(window.location.href);
        let searchParams = url.searchParams;
        const currentPage = searchParams.get(this.pageName);

        if (currentPage) {
            this.currentPage = currentPage;
        }
    }
}
</script>

<style scoped>
.list-enter-active, .list-leave-active {
    transition: all 0.4s;
}

.list-enter, .list-leave-to {
    opacity: 0;
    transform: translateY(30px);
}

.load-more {
    width: auto;
    height: 32px;
    padding: 5px 15px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/LazyLoad.vue